import { Api, Api as CoreApi } from "@bvm/core";

import { messageKeys as RegisterSingleVehicleFormMessageKeys } from "./components/registerSingleVehicle/register-single-vehicle-form";
import { messageKeys as LicensePlateStepMessageKeys } from "./components/registerSingleVehicle/steps/license-plate-step";
import { messageKeys as AdditionalCoveragesStepMessageKeys } from "./components/registerSingleVehicle/steps/additional-coverages-step";
import { messageKeys as StartingDateStepMessageKeys } from "./components/registerSingleVehicle/steps/starting-date-step";
import { messageKeys as MediaItemCardMessageKeys } from "./components/registerSingleVehicle/components/media-item-card";
import { messageKeys as MediaItemInfoMessageKeys } from "./components/registerSingleVehicle/components/media-item-info-block";
import { messageKeys as MediaItemModalMessageKeys } from "./components/shared/media-item-modal";

import { messageKeys as GpsQuoteRequestMessageKeys } from "./components/gpsPolicyQuoteRequest/gps-quote-request-form";
import { messageKeys as ContactInfoStepMessageKeys } from "./components/gpsPolicyQuoteRequest/steps/contact-info-step";
import { messageKeys as CompanyProfileStepMessageKeys } from "./components/gpsPolicyQuoteRequest/steps/company-profile-step";
import { messageKeys as CompanyInfoStepMessageKeys } from "./components/gpsPolicyQuoteRequest/steps/company-info-step";
import { messageKeys as AdditionalRisksStepMessageKeys } from "./components/gpsPolicyQuoteRequest/steps/additional-risks-step";
import { messageKeys as CoverageOverviewStepMessageKeys } from "./components/gpsPolicyQuoteRequest/steps/coverage-overview-step";
import { messageKeys as AddressInputMessageKeys } from "./components/shared/address-input";

import { messageKeys as ChangeAddressFormKeys } from "./components/addressChangeRequest/ChangeAddressForm";
import { messageKeys as ChangeAddressFormModalKeys } from "./components/addressChangeRequest/ChangeAddressFormModal";
import { messageKeys as ChangeCocFormKeys } from "./components/cocChangeRequest/ChangeCocForm";
import { messageKeys as ChangeCocFormModalKeys } from "./components/cocChangeRequest/ChangeCocFormModal";

import { messageKeys as DamageClaimKeys } from "./components/damageClaim/damage-claim-form";
import { messageKeys as DamageClaimSuccessKeys } from "./components/damageClaim/damage-claim-go-to-details";

import { messageKeys as GenericInviteMessageKeys } from "./components/genericInvite/generic-invite-form";
import { messageKeys as GenericUploadMessageKeys } from "./components/genericUpload/generic-upload-form";

const DEFAULT_LOCALE = "nl-NL";

/**
 * Initial messages where key=key to satisfy I18n on load while messages are loaded async.
 */
export function initialMessages(locale) {
  locale = locale || DEFAULT_LOCALE;
  const messages = [
    ...RegisterSingleVehicleFormMessageKeys,
    ...LicensePlateStepMessageKeys,
    ...AdditionalCoveragesStepMessageKeys,
    ...StartingDateStepMessageKeys,
    ...MediaItemCardMessageKeys,
    ...MediaItemInfoMessageKeys,
    ...MediaItemModalMessageKeys,
    ...GpsQuoteRequestMessageKeys,
    ...ContactInfoStepMessageKeys,
    ...CompanyProfileStepMessageKeys,
    ...CompanyInfoStepMessageKeys,
    ...AdditionalRisksStepMessageKeys,
    ...CoverageOverviewStepMessageKeys,
    ...AddressInputMessageKeys,
    ...ChangeAddressFormKeys,
    ...ChangeAddressFormModalKeys,
    ...ChangeCocFormKeys,
    ...ChangeCocFormModalKeys,
    ...DamageClaimKeys,
    ...DamageClaimSuccessKeys,
    ...GenericInviteMessageKeys,
    ...GenericUploadMessageKeys
  ].reduce((result, item) => {
    result[item] = item;
    return result;
  }, {});

  return { [locale]: messages };
}

export function loadI18n(vue, locale) {
  locale = locale || DEFAULT_LOCALE;
  Api.Lang.bulk(
    CoreApi.Lang.NL,
    Object.keys(initialMessages(locale)[locale])
  ).then(additionalMessages => {
    vue.$i18n.setLocaleMessage("nl-NL", additionalMessages);
  });
}
